import * as Sentry from '@sentry/angular'
import { LinkError } from '@apollo/client/errors'

/** ES module の export を書き換えずにエラー報告を検証できる委譲先。 */
export const sentryReporter = { captureException: Sentry.captureException }

/** 通信エラーを除外し、想定外のエラーを Sentry に報告する。 */
export const captureException = (error: unknown) => {
  // ネットワーク/トランスポート起因のエラー（接続断・非 2xx・レスポンスパース失敗）は
  // ユーザー環境依存のノイズになりやすいため Sentry へ送らない。
  // Apollo Client 4 では統一 ApolloError が廃止され、リンクチェーン由来のエラーは
  // LinkError.is で判定する（GraphQL エラーは CombinedGraphQLErrors になりここでは true にならない）。
  if (LinkError.is(error)) {
    return
  }
  sentryReporter.captureException(error)
}
